import getDomainPathFromPathReduxUtil from 'modules/redux/utils/get-domain-path-from-path'
import { REDUX_DOMAIN_MAP_KEY } from 'modules/redux/constants'

/**
 * Gets the key used to map the instances in `domain.data`.
 *
 * @example
 *
 * ```js
 *
 * let domainMapKey = getDomainMapKey('articles')
 *
 * const state = {
 *   articles : {
 *     data : {
 *      [domainMapKey] : instance,
 *     }
 *   },
 * }
 *
 *
 * ```
 * @param  {string} path
 * @returns {String|null}
 */
function getDomainMapKeyFromPathReduxUtil (path) {
  const domainPath = getDomainPathFromPathReduxUtil(path)
  return REDUX_DOMAIN_MAP_KEY[domainPath] || 'id'
}

export default getDomainMapKeyFromPathReduxUtil
